export const setItem = (key, params) => {
  return localStorage.setItem(key, params)
}

export const getItem = (key) => {
  return localStorage.getItem(key)
}
